<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Rispondi ai sondaggi</h2>
    <p>Imposta i filtri di ricerca</p>
    <div fxLayout="column" class="responsive-mat-form">

      <!-- Collaboratore -->
      <mat-form-field>
        <mat-label>Collaboratore</mat-label>
        <mat-select 
          [(value)]="parameters.collaboratore"
          (selectionChange)="onCollaboratoreSelectedChange($event)"
          [compareWith]="compareDTO" 
          [disabled]="!isJappTenantAdmin()"
        >
          <mat-option [value]="null">
            Tutti
          </mat-option>
          <mat-option *ngFor="let collaboratore of collaboratori" [value]="collaboratore">
            {{collaboratore.nome}} {{collaboratore.cognome}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Titolo -->
      <mat-form-field fxlayout="column">
        <mat-label>Cerca per titolo</mat-label>
        <input matInput [(ngModel)]="parameters.titolo" placeholder="Cerca per titolo">
      </mat-form-field>

      <!-- Date scadenza -->
      <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" class="responsive-mat-form">
        <!-- DataScadenzaDa -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
          [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
          [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
          <input matInput readonly="true" (click)="picker.open()" [(max)]="parameters.dataScadenzaA"
            [(ngModel)]="parameters.dataScadenzaDa" [matDatepicker]="picker" placeholder="Scegli data scadenza da">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <button mat-button *ngIf="parameters.dataScadenzaDa" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataScadenzaDa=null" (click)="parameters.initDataScadenzaDa=false">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <!-- DataScadenzaA -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <input matInput readonly="true" (click)="picker2.open()" [(min)]="parameters.dataScadenzaDa"
            [(ngModel)]="parameters.dataScadenzaA" [matDatepicker]="picker2" placeholder="Scegli data scadenza a">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <button mat-button *ngIf="parameters.dataScadenzaA" matSuffix mat-icon-button aria-label="Clear"
            (click)="parameters.dataScadenzaA=null">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- sezione risposta già data(hai gia risposto) -->
      <mat-form-field>
        <mat-select name="giaRisposto" [(ngModel)]="parameters.statoRispostaCollaboratore"
          placeholder="Stato risposta collaboratore selezionato"
          [disabled]="!isCollaboratoreSelected()">
          <mat-option [value]="null"> Tutti </mat-option>
          <mat-option [value]="true"> Hai risposto </mat-option>
          <mat-option [value]="false"> Non hai risposto </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-card-actions>
      <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
    </mat-card-actions>
    <br />
    <div *ngIf="parameters.showList" fxLayout="column">
      <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()" matSort
        (matSortChange)="setSort($event)" matSortDisableClear [dataSource]="parameters.dataSource">

        <!-- Id Column -->
        <ng-container matColumnDef="id">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Id sondaggio </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio"> {{sondaggio.id}} </td>
        </ng-container>

        <!-- titolo Column -->
        <ng-container matColumnDef="titolo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titolo </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.titolo}}</td>
        </ng-container>

        <!-- creatore Column -->
        <ng-container matColumnDef="creatore">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Creatore </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.creatore?.nome}} {{sondaggio.creatore?.cognome}} </td>
        </ng-container>

        <!-- dataScadenza Column -->
        <ng-container matColumnDef="dataScadenza">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Data scadenza </th>
          <td mat-cell *matCellDef="let sondaggio"> {{sondaggio.dataScadenza | date :'dd/MM/yyyy'}} </td>
        </ng-container>

        <!-- risposta già data Column -->
        <ng-container matColumnDef="giaRisposto" >
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Ha già risposto </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio" > {{ giaRisposto(sondaggio) }} </td>
        </ng-container>

        <!-- risposte Column -->
        <ng-container matColumnDef="risposte">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Risposte presenti </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio"> {{ numRisposte(sondaggio) }} </td>
        </ng-container>

        <!-- votanti Column -->
        <ng-container matColumnDef="votanti">
          <th fxHide fxShow.gt-md mat-header-cell *matHeaderCellDef mat-sort-header> Votanti </th>
          <td fxHide fxShow.gt-md mat-cell *matCellDef="let sondaggio"> {{ votanti(sondaggio) }} </td>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="detail">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let sondaggio">
            <div fxLayout="row" fxLayoutAlign="space-evenly center">
              <!-- devo memorizzare il collaboratore selezionato per portarmi dietro le sue informazioni alla pagina di risposta -->
              <button 
                mat-mini-fab color="primary"
                matTooltip="Rispondi"
                [disabled]="parameters.collaboratore == null"
                [routerLink]="['/risposta-sondaggio-detail/', sondaggio.id]"
                [queryParams]=" {collaboratoreSelezionatoId : parameters.collaboratore?.id}"
              > 
                <mat-icon>how_to_vote</mat-icon>
              </button>
              <button mat-mini-fab color="primary" matTooltip="Risultati" [routerLink]="['/risultati-sondaggio/', sondaggio.id] ">
                <mat-icon>pie_chart</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-card-actions>
          <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'sondaggio'})">Excel</button>
          <button fxHide fxShow.gt-md mat-raised-button
            (click)="exporter.exportTable('csv', {fileName:'sondaggio'})">Csv</button>
          <button fxHide fxShow.gt-md mat-raised-button
            (click)="exporter.exportTable('json', {fileName:'sondaggio'})">Json</button>
        </mat-card-actions>
        <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length"
          [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
      </div>

    </div>
  </mat-card-content>
</mat-card>